export default "__VITE_PUBLIC_ASSET__c0f1f216__"